<template>
    <div class="show-img">
        <img :src="params.data.imageUrl" class="rounded w-full img-checkin" @click="zoomImage = true" />
        <vs-popup class="showImg" :active.sync="zoomImage" title="Ảnh ghi nhận">
            <img :src="params.data.imageUrl" alt="" class="zoomImage">
        </vs-popup>
    </div>
</template>
<script>
export default {
    name: 'CellRendererActions',
    data() {
        return {
            zoomImage: false,
        }
    },
}
</script>
<style scoped>
.show-img .img-checkin {
    display: block;
    height: 65px;
    padding: 5px;
    width: 65px !important;
    /* object-fit: cover;
    object-position: center; */
    cursor: pointer;
}

.show-img {
    position: relative;
}

.zoomImage {
    width: 100%;
}

</style>
